import { render, staticRenderFns } from "./HotOfferIcon.vue?vue&type=template&id=6c7f67c6&scoped=true"
import script from "./HotOfferIcon.vue?vue&type=script&lang=js"
export * from "./HotOfferIcon.vue?vue&type=script&lang=js"
import style0 from "./HotOfferIcon.vue?vue&type=style&index=0&id=6c7f67c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7f67c6",
  null
  
)

export default component.exports